import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { DisplayService } from './../../core/services/display.service';
import { Component, OnInit } from '@angular/core';
import { AskDeleteComponent } from 'src/app/modals/ask-delete/ask-delete.component';

@Component({
  selector: 'app-display-edit',
  templateUrl: './display-edit.component.html',
  styleUrls: ['./display-edit.component.scss']
})
export class DisplayEditComponent implements OnInit {

  public display = {
    nummer: '',
    description: '',
    content: '',
    price: 0,
    rabatt: false,
    rabatt_staffelmenge: false,
    breite: null,
    hoehe: null,
    tiefe: null,
    zusatzinhalte: '',
    rabatt_hoehe: 0,
    bild: '',
    rabatte: []
  }

  constructor(private displayService: DisplayService, private activatedRoute: ActivatedRoute,
     private snack: MatSnackBar, private dialog: MatDialog, private router: Router) { }

  public loading = false;
  public id = 0;
  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      let id = params['id'];
      this.id = id;
      this.loading = true;
      this.displayService.get(id).subscribe(res => {
        this.loading = false;
        this.display.nummer = res['display']['nummer'];
        this.display.breite = res['display']['breite'];
        this.display.hoehe = res['display']['hoehe'];
        this.display.tiefe = res['display']['tiefe'];
        this.display.description = res['display']['beschreibung'];
        this.display.content = res['display']['inhalt'];
        this.display.bild = res['display']['abbildung64'];
        this.display.rabatt = res['display']['erhoehtRabatt'];
        this.display.rabatt_hoehe = res['display']['rabatt'];
        this.display.price = res['display']['preis'];
        this.display.zusatzinhalte = res['display']['zusatz'];
        this.display.rabatte = res['rabatte'];
        this.display.rabatt_staffelmenge = res['display']['staffelRabatt'];
      }, err => {
        this.loading = false;
        console.log(err);
      })
    });
  }

  public errors = [];
  public saving = false;
  public save() {
    this.saving = true;
    this.displayService.update(this.id, this.display).subscribe(res => {
      this.saving = false;
      this.snack.open('Display wurde erfolgreich gespeichert', '', {panelClass: 'success-snackbar'});
    }, err => {
      console.log(err);
      this.saving = false;
      if(err.status == 400) {
        Object.values(err.error.errors).map(e => this.errors.push(e['defaultMessage']));
      } else if(err.status == 990) {
        this.errors.push('Bitte geben Sie die Rabatt-Höhe an');
      }
    })
  }

  public deleting = false;
  askDelete() {
    this.dialog.open(AskDeleteComponent, {
      data: {
        title: 'Display '+this.display.nummer+' löschen?',
        body: 'Möchten Sie das Display mit der Nummer '+this.display.nummer+' wirklich löschen? Das Display kann, nachdem es gelöscht wurde, nicht mehr bestellt werden.'
      }
    }).afterClosed().subscribe(res => {
      if(!res)
        return;
      this.deleting = true;
      this.displayService.delete(this.id).subscribe(res => {
        this.deleting = false;
        this.snack.open('Das Display '+this.display.nummer+' wurde erfolgreich gelöscht.', '', {panelClass: 'success-snackbar'});
        this.router.navigateByUrl('/displays');
      }, err => {
        console.log(err);
        this.deleting = false;
      })
    })
  }
}
